const NEW_HOMES_LABEL = "new homes";

function isNewHomesChannel(channel?: string | null): boolean {
  if (!channel) {
    return false;
  }
  return channel.toLowerCase().includes(NEW_HOMES_LABEL);
}

function isNewHomesSalesDivision(salesDivision?: string | null): boolean {
  if (!salesDivision) {
    return false;
  }
  return salesDivision.toLowerCase().includes(NEW_HOMES_LABEL);
}

export { NEW_HOMES_LABEL, isNewHomesChannel, isNewHomesSalesDivision };
